<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <b-card header-bg-variant="secondary" header-text-variant="light">
      <template v-slot:header>
        <h5>رسید و حواله‌های مواد اولیه</h5>
      </template>
      <v-row>
        <v-col cols="5">
          <b-form-group label="از تاریخ">
            <date-picker v-model="exchangeFrom" :editable="true"></date-picker>
          </b-form-group>
        </v-col>
        <v-col cols="5">
          <b-form-group label="تا تاریخ">
            <date-picker v-model="exchangeTo" :editable="true"></date-picker>
          </b-form-group>
        </v-col>
        <v-col cols="2" class="mt-8">
          <b-btn @click="searchExchanges()" class="btn btn-dark"> جستجو </b-btn>
        </v-col>
      </v-row>

      <vue-excel-xlsx
        :disabled="!filteredExchanges.length"
        :data="filteredExchanges"
        class="darkGreen-mainBtn float-start my-4"
        :class="filteredExchanges.length ? 'white--text' : 'disabled-excel'"
        style="width: 135px; height: 35px"
        :columns="exchangesFieldsExcel"
        :file-name="'رسید و حواله‌های مواد اولیه'"
        :sheet-name="'رسید و حواله‌های مواد اولیه '"
      >
        <v-icon
          class="me-1"
          :class="filteredExchanges.length ? 'white--text' : ''"
        >
          mdi-file-excel-outline
        </v-icon>
        خروجی اکسل
      </vue-excel-xlsx>

      <v-btn
        :disabled="gettingReceipt || !filteredExchanges.length"
        class="darkRed-mainBtn white--text float-end my-4"
        @click="printReceipt()"
        style="width: 135px; height: 35px"
        depressed
        ><v-icon class="me-1">mdi-printer</v-icon>پرینت</v-btn
      >
      <b-table
        responsive
        show-empty
        id="detailsTable"
        :items="filteredExchanges"
        :fields="exchangesFields"
        empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
        empty-text="رکوردی برای نمایش وجود ندارد"
        striped
        :current-page="exchangeCurrentPage"
        :per-page="exchangePerPage"
        :busy="exchangeIsBusy"
      >
        <template slot="top-row">
          <td v-for="field in exchangesFields" :key="field.key">
            <b-form-input
              v-if="field.label != '#' && field.key != 'operation'"
              v-model="filters[field.key]"
              :placeholder="field.label"
            ></b-form-input>
          </td>
        </template>
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + exchangePerPage * (exchangeCurrentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(identifierEn)="data">
          <div style="text-align: center; vertical-align: middle">
            <a
              :href="'/warehouse/material/' + data.item.warehouseItemId"
              target="_blank"
              >{{ data.value }}</a
            >
          </div>
        </template>
        <template v-slot:cell(operation)="row">
          <b-button
            v-if="row.item._showDetails"
            variant="danger"
            @click="row.toggleDetails"
            >بستن
          </b-button>
          <b-button v-else variant="primary" @click="row.toggleDetails"
            >عملیات
          </b-button>
        </template>

        <template #row-details="row">
          <div
            class="animated fadeIn"
            style="text-align: center; vertical-align: middle"
          >
            <b-button
              class="mx-1"
              variant="primary"
              v-if="row.item.status != 'تایید نهایی'"
              @click="submitCorrection(row.item, row.item.warehouseId)"
              >اصلاح سند
            </b-button>
            <b-button
              class="mx-1"
              variant="success"
              v-if="row.item.status != 'تایید نهایی'"
              @click="approve(row.item)"
              >تایید نهایی
            </b-button>
            <b-button
              class="mx-1"
              variant="danger"
              v-if="row.item.status != 'تایید نهایی'"
              @click="doDelete(row.item)"
              >حذف تراکنش
            </b-button>
            <b-button
              class="mx-1"
              variant="warning"
              v-if="row.item.status == 'تایید نهایی'"
              @click="needEdit(row.item)"
              >نیاز به اصلاح
            </b-button>
          </div>
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="exchangeCurrentPage"
        :total-rows="filteredExchanges.length"
        :per-page="exchangePerPage"
        aria-controls="detailsTable"
        align="center"
        size="md"
        class="my-0"
      ></b-pagination>
      <br />
    </b-card>
    <router-view></router-view>
    <v-dialog v-model="editExchangeModal" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش {{ selectedExchange.type }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group
              :label="
                selectedExchange.type == 'رسید' ? 'تاریخ ورود' : 'تاریخ خروج'
              "
            >
              <date-picker v-model="edit.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group
              :label="
                selectedExchange.type == 'رسید' ? 'ساعت ورود' : 'ساعت خروج'
              "
            >
              <date-picker
                v-model="edit.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <v-text-field
              outlined
              dense
              :label="
                selectedExchange.type == 'رسید' ? 'حجم ورودی' : 'حجم خروجی'
              "
              v-model="edit.amount"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              :label="selectedExchange.type == 'رسید' ? 'مبدا' : 'مقصد'"
              v-model="edit.orgDes"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="edit.note"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="editExchangeModal = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="editSubmit(selectedExchange)">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">
        رسید و حواله‌های مواد اولیه
      </h3>
      <b-table :items="filteredExchanges" :fields="printFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import VueCkeditor from "vue-ckeditor2";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Var from "../../../variables"; // NOTE (IMPORT) to transfer variables from a special file of variables

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    VueCkeditor,
  },

  data: function () {
    return {
      guide: false,
      gettingReceipt: false,
      types: Var.allTypes,
      type: {},
      guide: false,
      warehouseInfo: {},
      products: [],
      otherWarehouses: [],
      productFilter: "all",
      changeInventoryDialog: false,
      entryDialog: false,
      exitDialog: false,
      transferDialog: false,
      editDialog: false,
      selectedExchange: {},
      selectedExchangeWarehouse: "",
      editExchangeModal: false,
      newProductDialog: false,
      detailDialog: false,
      advanceFilter: false,
      adFilter: {},
      info: [],
      selected: "",
      selected2: [],
      entry: {},
      exit: {},
      transfer: {},
      edit: {},
      newProduct: {},
      check: {
        name: false,
        material: false,
        coating: false,
        standard: false,
        diameter: false,
        length: false,
        number: false,
        description: false,
      },
      moment: moment,
      showProgress: false,
      items: [],
      filterOpt: [
        { key: "all", label: "همه" },
        { key: "exist", label: "اقلام دارای موجودی" },
        { key: "none", label: "اقلام بدون موجودی" },
      ],
      filter: null,
      fields: [
        { key: "index", label: "ردیف" },
        { key: "identifierFa", label: "شرح فارسی" },
        { key: "identifierEn", label: "شرح انگلیسی" },
        { key: "sum", label: "موجودی" },
        { key: "operation", label: "عملیات" },
      ],
      fields2: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "date", label: "تاریخ" },
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      isBusy2: false,
      TotalRows: 1,
      exchangeFrom: "",
      exchangeTo: "",
      allExchanges: [],
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "identifierEn", label: "کالا" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "operation", label: "عملیات" },
      ],
      exchangesFieldsExcel: [
        { field: "type", label: "نوع" },
        { field: "identifierEn", label: "کالا" },
        { field: "amount", label: "مقدار" },
        { field: "status", label: "وضعیت" },
        { field: "note", label: "توضیحات" },
        { field: "orgDes", label: "مبدا / مقصد" },
        { field: "userName", label: "کاربر" },
        { field: "date", label: "تاریخ" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "identifierEn", label: "کالا" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
      ],
      exchangeCurrentPage: 1,
      exchangePerPage: 10,
      exchangeIsBusy: false,
      filters: {
        type: "",
        identifierEn: "",
        amount: "",
        status: "",
        note: "",
        orgDes: "",
        userName: "",
        date: "",
      },
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    submitCorrection(exchange, warehouseId) {
      this.selectedExchange = exchange;
      this.selectedExchangeWarehouse = warehouseId;
      this.editExchangeModal = true;
      this.edit = JSON.parse(JSON.stringify(exchange));
      try {
        let myDateTime = this.edit.date.split(" ");
        this.edit.date = myDateTime[0];
        this.edit.time = myDateTime[1];
      } catch (error) {
        this.edit.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.edit.time = moment(new Date()).format("HH:mm");
      }
    },
    editSubmit(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/editTransaction",
        {
          transactionId: exchange.id,
          amount: this.edit.amount,
          date: this.edit.date + " " + this.edit.time,
          orgDes: this.edit.orgDes,
          note: this.edit.note,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("تایید با موفقیت انجام شد", "success");
            this.searchExchanges();
            this.editExchangeModal = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    approve(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/confirmation",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("تایید با موفقیت انجام شد", "success");
            this.searchExchanges();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    doDelete(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/delete",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("حذف با موفقیت انجام شد", "success");
            this.searchExchanges();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.searchExchanges();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.searchExchanges();
        });
    },
    needEdit(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/needEdit",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("ویرایش با موفقیت انجام شد", "success");
            this.searchExchanges();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    searchExchanges() {
      this.exchangeIsBusy = true;
      let startDate = this.exchangeFrom + " 00:00";
      let finishDate = this.exchangeTo + " 23:59";
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/perWarehouseType",
        {
          warehouseTypeId: this.types[1].id,
          startDate: startDate,
          finishDate: finishDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allExchanges = res.data;
            this.exchangeIsBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },
  computed: {
    filteredExchanges() {
      let myExchanges = [];

      if (this.allExchanges.length) {
        myExchanges = this.allExchanges.filter((item) => {
          return Object.keys(this.filters).every((key) =>
            String(item[key])
              .toLowerCase()
              .includes(this.filters[key].toLowerCase())
          );
        });
      }

      return myExchanges;
    },
  },

  mounted() {
    // this.getProducts();
    this.exchangeTo = moment(new Date()).format("jYYYY/jMM/jDD");
    this.exchangeFrom = moment(new Date())
      .subtract(7, "d")
      .format("jYYYY/jMM/jDD");
    this.searchExchanges();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.nav-pills {
  padding: 10px !important;
}
.changeInventory-btn {
  display: flex;
  align-items: center;
  flex-flow: column;
}
</style>
